// extracted by mini-css-extract-plugin
export var dropdownContainer = "_oy-0";
export var leftAlign = "_oy-4";
export var listItem = "_oy-2";
export var listItemWrapper = "_oy-1";
export var operationText = "_oy-3";